module.exports = __webpack_public_path__ + "static/media/helexia_icon_date.84639304.svg";